import React from 'react';
import {usePurchase} from "../../../utilities/context/purchase/purchase-context";
import Row from "../../UI/Row";
import Loading from "../../UI/Loading";

const DisplayItem = ({addon}) => {
    return (
        <Row className="border-b justify-between">
            <div>{addon.name}</div>
            <div>{parseFloat(addon.costs.suscribing_cost).toFixed(2)}€</div>
        </Row>
    )
}

const PurchaseRecap = ({loading = false}) => {

    const {selectedAddons} = usePurchase();

    const getTotal = () => {
        let total = 0;
        selectedAddons.forEach((addon) => {
            total += addon.costs.suscribing_cost;
        });
        return parseFloat(total).toFixed(2);
    }

    return (
        <div className="w-full my-8 text-left">
            <div className="text-2xl text-ea_yellow mb-4">Hai selezionato i seguenti prodotti: </div>
            {selectedAddons && selectedAddons.length > 0 && selectedAddons.map((addon, i) => <DisplayItem addon={addon} key={i} />)}
            {loading ?
                <Row className="justify-end">
                    <Loading label="Calcolo in corso" className="text-xs"/>
                </Row>
                :
                <div className="text-right">Totale: <span className="text-xl font-medium">{getTotal()}€</span></div>
            }

        </div>
    );
};

export default PurchaseRecap;